export default __webpack_public_path__ + "static/media/Janice_Scholl_AHV_In_Moms_We_Trust.9dfe5f67.jpg";